<script>
export default {
  name: "ExtendPaymentCompletes",
  data () {
    return {
    }
  },
  created() {
  },
  methods: {
    moveToHome () {
      this.$router.push({ name: 'HomeIndex' })
    },
  },

}
</script>

<template>
  <v-container>
    <h1 class="text-center">
      ありがとうございます
    </h1>
    <div class="text-center ma-2 lang_lbl">{{$t('view.ありがとうございます')}}</div>
    <h1 class="text-center">
      注文を承りました
    </h1>
    <div class="text-center ma-2 lang_lbl">{{$t('view.注文完了メッセージ_1')}}</div>

    <v-row>
      <v-col cols="12">
        <div class="text-center subtitle-1">
          登録されているメールアドレスにご注文内容が記載されたメールをお送りいたします。
        </div>
        <div class="text-center ma-2 lang_lbl">{{$t('view.注文完了メッセージ_2')}}</div>
      </v-col>
      <v-col cols="12">
        <div class="text-center">
          <v-icon
            color="primary"
            x-large
          >
            mdi-truck-delivery-outline
          </v-icon>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="text-center">
          <v-btn
            :block="$vuetify.breakpoint.mdAndDown"
            color="primary"
            outlined
            @click="moveToHome"
          >
            <v-icon>mdi-home-outline</v-icon>ホームに戻る
            <div class="lang_lbl">{{$t('view.ホームに戻る')}}</div>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
